"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Icon = function (props) {
    var iconName = props.iconName, _a = props.spritePath, spritePath = _a === void 0 ? "/symbol-defs.svg" : _a, className = props.className, utilityAndButtonIconProps = __rest(props, ["iconName", "spritePath", "className"]);
    var _b = distillUtilityClasses_1.default(utilityAndButtonIconProps), utilityClasses = _b[0], buttonIconProps = _b[1];
    var classes = __spreadArray(["c-icon", className], utilityClasses);
    return (react_1.default.createElement("svg", __assign({ className: classes.join(" ") }, buttonIconProps), props.iconName && react_1.default.createElement("use", { href: spritePath + "#" + iconName })));
};
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map